import { get, del, post, put } from '@api/request';

export const updateDashboardConfig = async (
  { appraisalService },
  authenticationToken,
  { payload, dashboardID },
) => {
  const url = `${appraisalService}/dashboard/configuration/${dashboardID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const insertDashboardConfig = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/dashboard/configurations`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchUserRoles = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/dashboard/configuration/alluserroles`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchDashboardUserRoles = async (
  { appraisalService },
  authenticationToken,
  { dashboardID },
) => {
  const url = `${appraisalService}/dashboard/configuration/${dashboardID}/roles`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertDashboardUserRole = async (
  { appraisalService },
  authenticationToken,
  { dashboardID, payload },
) => {
  const url = `${appraisalService}/dashboard/configuration/${dashboardID}/roles`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteDashboardUserRole = async (
  { appraisalService },
  authenticationToken,
  { dashboardRoleID },
) => {
  const url = `${appraisalService}/dashboard/configuration/role/${dashboardRoleID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchDashboardConfig = async (
  { appraisalService },
  authenticationToken,
  { dashboardID },
) => {
  const url = `${appraisalService}/dashboard/configuration/${dashboardID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchDashboardConfigs = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/dashboard/configurations`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const deleteDashboardConfig = async (
  { appraisalService },
  authenticationToken,
  { dashboardID },
) => {
  const url = `${appraisalService}/dashboard/configuration/${dashboardID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchDashboardQueries = async (
  { appraisalService },
  authenticationToken,
  { dashboardID },
) => {
  const url = `${appraisalService}/dashboard/configuration/${dashboardID}/queries`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchDashboardQuery = async (
  { appraisalService },
  authenticationToken,
  { dashboardQueryID },
) => {
  const url = `${appraisalService}/dashboard/configuration/query/${dashboardQueryID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const deleteDashboardQuery = async (
  { appraisalService },
  authenticationToken,
  { dashboardQueryID },
) => {
  const url = `${appraisalService}/dashboard/configuration/query/${dashboardQueryID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const insertDashboardQuery = async (
  { appraisalService },
  authenticationToken,
  { dashboardID, payload },
) => {
  const url = `${appraisalService}/dashboard/configuration/${dashboardID}/queries`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateDashboardQuery = async (
  { appraisalService },
  authenticationToken,
  { dashboardQueryID, payload },
) => {
  const url = `${appraisalService}/dashboard/configuration/query/${dashboardQueryID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const validateDashboardQuery = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/dashboard/configuration/validatequery`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchDashboardQueryResults = async (
  { appraisalService },
  authenticationToken,
  { dashboardQueryID },
) => {
  const url = `${appraisalService}/dashboard/configuration/query/${dashboardQueryID}/execute?page=2&pageSize=1000`;
  const { body } = await get(authenticationToken, url);
  return body;
};
